import { getPriceComponentsAndOrderCharges } from '../../../utils/CartUtils';
import { getDisplayableDiscounts } from '../../../utils/DishUtils';
import { createSelector } from 'reselect';
import { applyOperatorsToManagerDiscounts } from '../../../utils/ChargeUtils';
import { deliveryTypeSelector } from './deliveryTypeSelector';

const inputSelectors = [
  state => state.order.orderItems,
  state => state.session.menu,
  state => state.session.menu.chargesV2,
  state => state.session.organization,
  state => state.order.address,
  state => state.order.managerDiscount,
  state =>
    state.checkout
      ? state.checkout.payments.reduce(function(accumulator, payment) {
          return accumulator + (payment.tip ? payment.tip : 0);
        }, 0)
      : 0,
  state => state.order.manualDeliveryFee,
  state => deliveryTypeSelector(state),
];

export function derivedOrderDataFn(
  orderItems,
  menu,
  rawChargesV2,
  organization,
  address,
  managerDiscount,
  tip,
  manualDeliveryFee,
  dispatchType,
) {
  const dispatchTime = 'asap';
  const source = 'source';
  const platform = 'callcenter';
  const { timezone } = organization;

  const chargesV2 = applyOperatorsToManagerDiscounts({
    chargesV2: rawChargesV2,
    amount: managerDiscount.amount,
    discountUnit: managerDiscount.unit,
  });

  const { priceComponents, orderCharges } = getPriceComponentsAndOrderCharges({
    dispatchType,
    dispatchTime,
    orderItems,
    tip,
    source,
    platform,
    chargesV2,
    timezone,
    organization,
    address,
    manualDeliveryFee,
  });

  const displayableDiscounts = getDisplayableDiscounts({
    menu,
    deliveryType: dispatchType,
    deliveryTime: dispatchTime,
    orderItems,
    source,
    platform,
    orderCharges,
  });

  return { priceComponents, displayableDiscounts, orderCharges };
}

export const derivedOrderData = createSelector(
  inputSelectors,
  derivedOrderDataFn,
);
